'use client'
import { Link } from 'react-router-dom';
import { useState, useRef } from 'react'
import {
  Dialog,
  DialogPanel,
} from '@headlessui/react'
import {
  Bars3Icon,
  XMarkIcon,
} from '@heroicons/react/24/outline'
import Swal from 'sweetalert2'
import cancelReservation from '../../services/cancelReservation'

import cancelar from "../../assets/Cancelar.png";
import Contactanos from "../../assets/Contactanos.png";
import Check from "../../assets/Check.png";
import Destinos from "../../assets/Destinos destacados.png";
import Inicio from "../../assets/Inicio.png";
import logo from '../../assets/logoletoh1.png';
import logo2 from '../../assets/logoletoh2.png';
import nosotros from "../../assets/nosotros.png";
import Vector from "../../assets/Vector.png";


const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const destinosRef = useRef(null);

  const scrollToDestinos = () => {
    destinosRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleCancelReservation = async () => {

    const { value: reservationId } = await Swal.fire({
      title: "Ingresa el número de reserva",
      input: "number",
      inputPlaceholder: "Número de reserva",
      inputAttributes: {
        min: 1,
        step: 1
      },
      showCancelButton: true,
      confirmButtonText: "Cancelar reserva",
      cancelButtonText: "Volver",
      showLoaderOnConfirm: true,
      customClass: {
        confirmButton: "bg-[#1F4F51]",
        cancelButton: "swal-custom-cancel"
      },
      preConfirm: async (reservationId) => {
        try {
          const parsedId = parseInt(reservationId, 10);
          if (!parsedId || isNaN(parsedId) || parsedId <= 0) {
            Swal.showValidationMessage("Debes ingresar un número de reserva válido");
            return;
          }

          const response = await cancelReservation(parsedId);

          if (response.status !== 200) {
            throw new Error(response.error || "Error al cancelar la reserva");
          }

          return response;
        } catch (error) {
          Swal.showValidationMessage(`Error: ${error.message}`);
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });

    if (reservationId) {

      Swal.fire({
        title: "Reserva cancelada",
        text: `${reservationId.message}`,
        imageUrl: Check, 
        imageWidth: 80, 
        imageHeight: 80, 
        customClass: {
          confirmButton: "bg-[#1F4F51] hover:bg-[#17403F] text-white font-semibold py-2 px-6 rounded-md w-40",
        }
      });
    }
  };

  return (
    <header className="bg-[#FBF3F0]">
      <div className="bg-[#1F4F51] text-white text-center p-2 text-sm font-poppins">
        Tu inmueble a cargo de <span className="font-bold">LetoH</span>, renta garantizada.
        <Link to="/rent" className="underline text-white font-semibold"> Más información aquí.</Link>
      </div>
      <nav aria-label="Global" className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8">
        <div className="flex flex-1 justify-center lg:justify-start">
          <Link to="/home" className="-m-1.5 p-1.5">
            <span className="sr-only">LetoH</span>
            <img alt="LetoH" src={logo} className="h-8 w-auto" />
          </Link>
        </div>
        {/* Menú visible en pantallas grandes */}
        <div className="hidden lg:flex lg:gap-6">
          <Link to="/home" className="text-gray-800 font-poppins hover:text-[#1F4F51]">Inicio</Link>
          <a href="/home#destacados" onClick={scrollToDestinos} className="text-gray-800 font-poppins hover:text-[#1F4F51]">Destinos destacados</a>
          <Link to="/aboutUs" className="text-gray-800 font-poppins hover:text-[#1F4F51]">Acerca de nosotros</Link>
          <Link to="/contact" className="text-gray-800 font-poppins hover:text-[#1F4F51]">Contáctanos</Link>
          <Link to="#" onClick={handleCancelReservation} className="text-gray-800 font-poppins hover:text-[#1F4F51]">
            Cancelar Reserva
          </Link>
        </div>

        <div className="flex lg:hidden">
          <button
            type="button"
            onClick={() => setMobileMenuOpen(true)}
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
          >
            <Bars3Icon aria-hidden="true" className="size-6" />
          </button>
        </div>
      </nav>
      <Dialog open={mobileMenuOpen} onClose={setMobileMenuOpen} className="lg:hidden">
        <div className="fixed inset-0 bg-black/30" />

        {/* Menú en la esquina superior derecha */}
        <DialogPanel className="fixed top-0 right-0 h-full z-50 w-64 bg-white shadow-lg rounded-bl-lg transition-transform">

          {/* Contenedor del logo y botón de cerrar con fondo */}
          <div className="flex items-center justify-center w-full bg-[#1F4F51] py-3 relative">
            <Link to="/home" className="flex justify-center">
              <span className="sr-only">LetoH</span>
              <img alt="LetoH" src={logo2} className="h-8 w-auto" />
            </Link>
            <button
              type="button"
              onClick={() => setMobileMenuOpen(false)}
              className="absolute right-4 text-white"
            >
              <span className="sr-only">Cerrar menú</span>
              <XMarkIcon aria-hidden="true" className="size-6" />
            </button>
          </div>

          {/* Enlaces del menú */}
          <div className="mt-4 space-y-2 z-10 ">
            <Link to="/home" className="flex items-center gap-1 px-4 py-2 text-md font-poppins text-gray-800 no-underline hover:bg-gray-100">
              <img src={Inicio} alt="" className="w-6 h-4 object-contain" />
              Inicio
            </Link>
            <a href="/home#destacados" onClick={() => setMobileMenuOpen(false)} className="flex items-center gap-1 px-4 py-2 text-md font-poppins text-gray-800 no-underline hover:bg-gray-100">
              <img src={Destinos} alt="" className="w-6 h-4 object-contain" />
              Destinos destacados
            </a>
            <Link to="/aboutUs" className="flex items-center gap-1 px-4 py-2 text-md font-poppins text-gray-800 no-underline hover:bg-gray-100">
              <img src={nosotros} alt="" className="w-6 h-4 object-contain" />
              Acerca de nosotros
            </Link>
            <Link to="/contact" className="flex items-center gap-1 px-4 py-2 text-md font-poppins text-gray-800 no-underline hover:bg-gray-100">
              <img src={Contactanos} alt="" className="w-6 h-4 object-contain" />
              Contáctanos
            </Link>
            <Link to="#" onClick={handleCancelReservation} className="flex items-center gap-1 px-4 py-2 text-md font-poppins text-gray-800 no-underline hover:bg-gray-100">
              <img src={cancelar} alt="" className="w-6 h-4 object-contain" />
              Cancelar reserva
            </Link>
          </div>
          {/* Imagen de fondo centrada */}
          <div className="absolute bottom-80 left-1/2 transform -translate-x-1/2">
            <img src={Vector} alt="" className="w-40" />
          </div>

        </DialogPanel>
      </Dialog>


    </header>
  )
}

export default Header;
